import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getApiErrorMessage(error, fallback = 'Bir hata oluştu. Lütfen tekrar deneyin.') {
  if (!error?.response) {
    if (error?.code === 'ERR_NETWORK') {
      return 'Sunucuya bağlanılamadı. İnternet bağlantınızı kontrol edip tekrar deneyin.';
    }
    return fallback;
  }

  const data = error.response.data;
  if (typeof data?.detail === 'string') return data.detail;
  if (typeof data?.error?.message === 'string') return data.error.message;

  if (data?.error?.code === 'validation_error' && Array.isArray(data.error.details)) {
    const messages = data.error.details.map((item) => item.msg).filter(Boolean);
    if (messages.length > 0) return messages.join(', ');
  }

  return fallback;
}
